export enum MessageToClientType {
  Echo = 'echo'
}